import React from 'react';
import { PageLayout } from '../components/layout/PageLayout';
import { SEO } from '../components/SEO';

export function TermsOfService() {
  return (
    <PageLayout>
      <SEO 
        title="Terms of Service - CloseCircle"
        description="Read about CloseCircle's terms of service and user agreement policies."
      />
      <main className="max-w-4xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">Terms of Service</h1>
        
        <div className="prose dark:prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Acceptance of Terms</h2>
            <p className="text-gray-600 dark:text-gray-300">
              By accessing or using CloseCircle, you agree to be bound by these Terms of Service and all applicable laws and regulations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">User Conduct</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              You agree to use CloseCircle responsibly and to not:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
              <li>Harass, abuse, or harm other users</li>
              <li>Share false or misleading information</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Attempt to compromise platform security</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Account Security</h2>
            <p className="text-gray-600 dark:text-gray-300">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </p>
          </section>
        </div>
      </main>
    </PageLayout>
  );
}